/** The languages the editor is translated to (public/locales/<code>), each named in itself, as pickers show them. */
export const LANGUAGES = [
  { code: "pt", label: "Português" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
] as const;

export type Language = (typeof LANGUAGES)[number]["code"];

export const LANGUAGE_CODES: Language[] = LANGUAGES.map(({ code }) => code);

/** A browser's or i18next's language ("es-419", "pt_BR", "FR") as one the editor has; English when it has none. */
export const toLanguage = (language?: string | null): Language => {
  const base = (language ?? "").toLowerCase().split(/[-_]/)[0];
  return LANGUAGE_CODES.find(code => code === base) ?? "en";
};

/** The language a published Keepo's own texts come in (the API's KeepoDictionary): Portuguese or English. */
export type KeepoLanguage = "pt" | "en";

/**
 * Spanish, French, German and Italian have no Keepo texts of their own (the page's menu, form and buttons), so a
 * Keepo of an account in them is in English, as their emails; a language the editor doesn't have, or none, is
 * Portuguese. The same rule as the API (EmailText::normalizeLanguage), so the preview shows what gets published.
 */
export const keepoLanguageOf = (language?: string | null): KeepoLanguage => {
  const base = (language ?? "").toLowerCase().split(/[-_]/)[0];
  return base !== "pt" && LANGUAGE_CODES.some(code => code === base) ? "en" : "pt";
};

/** The value of the page's <html lang> for the editor's language: Brazilian Portuguese, else the language. */
export const htmlLangOf = (language?: string | null) => {
  const editorLanguage = toLanguage(language);
  return editorLanguage === "pt" ? "pt-BR" : editorLanguage;
};
